import type { TaskDto } from '@/api/generated';

export interface TaskGroups {
  thisWeek: TaskDto[];
  twoWeeks: TaskDto[];
  later: TaskDto[];
  blocked: TaskDto[];
  done: TaskDto[];
}

function daysUntil(dueIso: string, today: Date): number {
  const due = new Date(dueIso.slice(0, 10));
  const t = new Date(today.toISOString().slice(0, 10));
  return Math.round((due.getTime() - t.getTime()) / 86_400_000);
}

export function groupTasks(tasks: TaskDto[], today: Date = new Date()): TaskGroups {
  const blocked = tasks.filter((t) => t.status === 'Blocked');
  const done = tasks.filter((t) => t.status === 'Done');
  const open = tasks.filter((t) => t.status === 'Open' || t.status === 'InProgress');

  const thisWeek: TaskDto[] = [];
  const twoWeeks: TaskDto[] = [];
  const later: TaskDto[] = [];

  for (const t of open) {
    const d = daysUntil(t.due, today);
    if (t.urgent || d <= 7) thisWeek.push(t);
    else if (d <= 14) twoWeeks.push(t);
    else later.push(t);
  }

  return { thisWeek, twoWeeks, later, blocked, done };
}
